import {
  about_en,
  about_ko,
  aboutGridItemLocalization_en,
  aboutGridItemLocalization_ko,
  AboutGridItemLocalizationType,
} from "./aboutLocalization";
import {
  featuredWorkLocalizations_en,
  featuredWorkLocalizations_ko,
  FeaturedWorkLocalizationType,
} from "./featuredWorkLocalization";
import { j2h_rules_en, j2h_rules_ko } from "./rules/j2hRuleLocalization";
import {
  role_distributor_rules_en,
  role_distributor_rules_ko,
} from "./rules/roleDistributorRuleLocalization";
import { wtb_rules_en, wtb_rules_ko } from "./rules/wtbRuleLocalization";
import {
  single_roulette_rules_en,
  single_roulette_rules_ko,
} from "./rules/singleRoleRouletteRuleLocalization";
import {
  team_builder_rules_en,
  team_builder_rules_ko,
} from "./rules/teamBuilderRuleLocalization";
import {
  lucky_draw_rules_en,
  lucky_draw_rules_ko,
} from "./rules/luckyDrawRuleLocalization";
import {
  dealerjack_rules_en,
  dealerjack_rules_ko,
  dealerjack_translations_en,
  dealerjack_translations_ko,
} from "./rules/dealerjackRuleLocalization";
import quizRuleLocalization from "./rules/quizRuleLocalization";
import { fightSimulatorRuleLocalization } from "./rules/fightSimulatorRuleLocalization";

type TranslationResources = {
  lang: string;
  home: string;
  about: string;
  game: string;
  usefulTools: string;
  roleRouletteDescription: string;
  singleRoleRouletteDescription: string;
  teamBuilderDescription: string;
  luckyDrawDescription: string;
  quizDescription: string;
  team: string;
  individual: string;
  cooperative: string;
  players: string;
  offlineUse: string;
  letsPlay: string;
  backToHome: string;
  createRoom: string;
  joinRoom: string;
  reconnect: string;
  room: string;
  private: string;
  status: string;
  password: string;
  enterRoomName: string;
  usernameRequired: string;
  roomNameRequired: string;
  roomInGame: string;
  enterUsername: string;
  leaveRoom: string;
  start: string;
  startGame: string;
  rule: string;
  joinMessage: string;
  leaveMessage: string;
  typeMessage: string;
  chat: string;
  onlineUsers: string;
  // Private chat translations
  publicChat: string;
  privateChat: string;
  newConversation: string;
  selectParticipants: string;
  selectAtLeastOne: string;
  selectedOnePlayer: string;
  selectedMultiplePlayers: string;
  noAvailablePlayers: string;
  startConversation: string;
  noConversations: string;
  clickNewToStart: string;
  noMessages: string;
  joinedConversation: string;
  leftConversation: string;
  round: string;
  howToPlay: string;
  gameSoon: string;
  gameOver: string;
  backToRoom: string;
  enterMemo: string;
  gameSetting: string;
  contact: string;
  links: string;
  featuredWork: string;
  currentProject: string;
  skillStack: string;
  coreSkill: string;
  programming: string;
  framework: string;
  others: string;
  addAI: string;
  skip: string;
  serverDisconnected: string;
  reconnecting: string;
  retry: string;
  aiPlayer: string;
  reconnectionDialog: {
    title: string;
    message1: string;
    seconds: string;
    message2: string;
    question: string;
    autoCancel: string;
    reconnect: string;
    leave: string;
  };
  services: string;
  servicesSubtitle: string;
  About: {
    name: string;
    intro: string[];
    onGoing: {
      lingtopleDesc: string;
      inGraceTitle: string;
      inGraceDesc: string;
    };
    title: {
      noAI: string;
      withAI: string;
      ios: string;
      flutter: string;
      react: string;
    };
    desc: {
      selfTaught: string;
      designSkill: string;
      ideaToImplementation: string;
      multipleDevelop: string;

      amplifyWithAI: string;
      aiCodeReview: string;

      iosLeadDev: string;
      swiftExperience: string;

      flutterLeadProject: string;
      flutterNativePerf: string;
      flutterWebFirst: string;

      reactFullstack: string;
      reactStyling: string;
      reactSocket: string;
      reactBackend: string;
    };
  };
  J2H: {
    title: string;
    Square: string;
    Sky: string;
    Forest: string;
    River: string;
    City: string;
    rules: string[];
    setting: string;
    squareMessage: string;
    hometownAssignment: string;
    movementRules: string;
    gamePhases: string;
    squarePhase: string;
    areaPhase: string;
    communicationRules: string;
    areaInfo: string;
    areaAndWinCondition: string;
    winCondition: string;
    playersInArea: string;
    playersInHometown: string;
    strategyAndExample: string;
    strategyTips: string;
    strategyGuide: string;
    gameExample: string;
    gameExampleTitle: string;
  };
  WTB: {
    title: string;
    rules: string[];
    humanPlayer: string;
    gamePhases: string;
    answerPhase: string;
    votingPhase: string;
    aiVotingPhase: string;
    scoringSystem: string;
    successTips: string;
    answerSubmitted: string;
    enterAnswer: string;
    submitAnswer: string;
    votePrompt: string;
    selectAnswer: string;
    roundResults: string;
    topAnswers: string;
    aiVotingTitle: string;
    voteSubmitted: string;
    selectBot: string;
    finalResults: string;
    botReveal: string;
    votingResults: string;
    correctGuesses: string;
    gameResults: string;
    correctGuessers: string;
    myAnswer: string;
    selected: string;
    mostVoted: string;
    points: string;
    continue: string;
    botCount: string;
    answerTime: string;
    votingTime: string;
    language: string;
  };
  featuredWorks: FeaturedWorkLocalizationType;
  viewProject: string;
  aboutGridItemType: AboutGridItemLocalizationType;
  SingleRoleRoulette: {
    title: string;
    rules: string[];
    inProgress: string;
    waiting: string;
    rouletteMode: string;
    moderatorMode: string;
    notSet: string;
    enterRoleName: string;
    roleNameExists: string;
    roleNameLength: string;
    quantityMinimum: string;
    enterBasicRole: string;
    setTotalPlayersMinimum: string;
    totalLabelCountExceedsTotalPlayers: string;
    gameMode: string;
    totalPlayers: string;
    rouletteModeDescription: string;
    moderatorModeDescription: string;
    playerCount: string;
    add: string;
    people: string;
    selectVoterCount: string;
    secretVoteDescription: string;
    // UI texts
    player: string;
    checkRole: string;
    confirmComplete: string;
    passToNextPlayer: string;
    passToNextPlayerAfterCheck: string;
    allPlayersConfirmed: string;
    secretVote: string;
    viewResults: string;
    voteResults: string;
    allVotesComplete: string;
    confirmVoteResults: string;
    roleDistributionResults: string;
    votingInProgress: string;
    agree: string;
    disagree: string;
    complete: string;
  };
  TeamBuilder: {
    title: string;
    rules: string[];
    // Settings
    teamAssignmentSettings: string;
    totalPlayers: string;
    people: string;
    teamCount: string;
    teams: string;
    maxTeamsCanBeSet: string;
    startTeamAssignment: string;
    // Results
    teamAssignmentResults: string;
    totalPlayersAssignedMessage: string;
    team: string;
    peopleUnit: string;
    playerNumberUnit: string;
    fullListPlayerOrder: string;
    reassignTeams: string;
  };
  LuckyDraw: {
    title: string;
    rules: string[];
    // Mode buttons
    numberMode: string;
    prizeMode: string;
    // Drawing states
    waiting: string;
    drawing: string;
    stopDrawing: string;
    drawnNumber: string;
    winningPrize: string;
    startDrawing: string;
    draw: string;
    drawingComplete: string;
    // Status
    remainingNumbers: string;
    remainingPrizes: string;
    units: string;
    drawHistory: string;
    restart: string;
    backToSettings: string;
    // Number mode
    numberModeSettings: string;
    minimumNumber: string;
    maximumNumber: string;
    drawFromRange: string;
    maxNumberMustBeGreater: string;
    startDraw: string;
    // Prize mode
    prizeModeSettings: string;
    addPrize: string;
    prizeName: string;
    enterPrizeName: string;
    quantity: string;
    add: string;
    registeredPrizes: string;
    addPrizesFirst: string;
  };
  RoleDistributor: {
    title: string;
    rules: string[]; // from roleDistributorRuleLocalization
    // Settings
    gameSettingsTitle: string;
    hostMode: string;
    hostModeDescription: string;
    gameStartInfo: string;
    // UI Labels
    notSet: string;
    peopleExpected: string;
    specialRoles: string;
    gameInProgress: string;
    waiting: string;
    roleStatus: string;
    settings: string;
    status: string;
    expand: string;
    collapse: string;
    roleSettingsHost: string;
    inProgress: string;
    hostRevealMode: string;
    unassigned: string;
    moderator: string;
    roleAssignmentResults: string;
    myRole: string;
    hostExcluded: string;
    totalParticipants: string;
    participating: string;
    // Form inputs
    basic: string;
    special: string;
    basicPlaceholder: string;
    specialPlaceholder: string;
    addedSpecialRoles: string;
    delete: string;
    quantity: string;
    addSpecialRole: string;
    // Buttons
    endDistribution: string;
    edit: string;
    start: string;
    completeSettings: string;
    settingsCompleted: string;
    // Error messages
    enterRoleName: string;
    roleNameTooLong: string;
    roleNameExists: string;
    quantityMinimum: string;
    enterBasicRole: string;
    noParticipants: string;
    specialRolesExceedPlayers: string;
    serverDisconnected: string;
    settingsCompleteFailed: string;
    // Action-related
    actionPhaseActive: string;
    actionPhaseInactive: string;
    startActionPhase: string;
    endActionPhase: string;
    phaseStartedAt: string;
    myActions: string;
    canUseActions: string;
    waitForPhase: string;
    recentUsages: string;
    agree: string;
    disagree: string;
    selectTarget: string;
    selectVoteTarget: string;
    makeChoice: string;
    makeSecretChoice: string;
    secretVoteNote: string;
    confirm: string;
    cancel: string;
    actionPhaseNotActive: string;
    actionAlreadyUsed: string;
    noAvailableTargets: string;
    selectRoleToSee: string;
    noRolesToSee: string;
    host: string;
    actionPhase: string;
    specialActions: string;
    actionHistory: string;
    noActions: string;
    noHistory: string;
    used: string;
    actionResults: string;
    publicResults: string;
    yourResults: string;
    noResults: string;
    result: string;
    gameSettingsTip: string;
    clickToStart: string;
    clickToEnd: string;
    selectActions: string;
    assignedActions: string;
    // Preset-related
    presetTitle: string;
    selectGame: string;
    selectCharacter: string;
    characterDescription: string;
    faction: string;
    goodFaction: string;
    evilFaction: string;
    mafiaFaction: string;
    citizenFaction: string;
    avalonGuide: string;
    mafiaGuide: string;
    specialAbilities: string;
    noSpecialAbilities: string;
    select: string;
    defaultRoleSection: string;
    specialRoleSection: string;
    // 능력별 이름과 설명
    assassinate: string;
    assassinateDesc: string;
    protect: string;
    protectDesc: string;
    investigate: string;
    investigateDesc: string;
    nominate: string;
    nominateDesc: string;
    vote: string;
    voteDesc: string;
    vote_choice: string;
    vote_choiceDesc: string;
    secret_vote_choice: string;
    secret_vote_choiceDesc: string;
    see_roles: string;
    see_rolesDesc: string;
    // Action result messages
    assassinationSuccess: string;
    assassinationFailed: string;
    protectionSuccess: string;
    investigationResult: string;
    actionComplete: string;
    nominateSuccess: string;
    voteChoiceSuccess: string;
    seeRolesSuccess: string;
    // See roles related
    seeRolesLabel: string;
    seeRolesTitle: string;
    seeRolesNote: string;
    seeRolesPreview: string;
    // Timer related
    seconds: string;
    noTimeLimit: string;
    timerExpired: string;
    invalidDuration: string;
    startAction: string;
    endAction: string;
    // Action modify related
    modifyAction: string;
    modifyActionDesc: string;
    changeTarget: string;
    cancelAction: string;
    tapToModify: string;
  };
  Dealerjack: {
    title: string;
    rules: string[];
    // Import all translations from dealerjackRuleLocalization
    [key: string]: any;
    // Common UI elements (explicitly typed)
    dealer: string;
    handValue: string;
    showing: string;
    placeBet: string;
    bet: string;
    yourTurn: string;
    roundResults: string;
    payout: string;
    lose: string;
    waitingForGame: string;
    enableChat: string;
    disableChat: string;
    // In-game settings
    completeSettings: string;
    configuringGame: string;
    settingsInProgress: string;
    hostConfiguringGame: string;
    pleaseWait: string;
    // Battle Mode specific
    placeBattleBet: string;
    availableChips: string;
    battleTurn: string;
    battleResults: string;
    battleRoundsRemaining: string;
    totalChips: string;
    viewFinalResults: string;
    finalBattleResults: string;
    battleWinner: string;
    finalRank: string;
    profit: string;
    backToLobby: string;
    bettingPhase: string;
    playerTurn: string;
    sortedByChips: string;
    betPlaced: string;
  };
  Quiz: {
    [key: string]: any;
  };
  FightSimulator: {
    [key: string]: any;
  };
  ProductLinks: {
    pageTitle: string;
    pageDescription: string;
    developerCard: {
      title: string;
      description: string;
      viewPortfolio: string;
    };
    services: {
      lingple: {
        subtitle: string;
        links: {
          home: string;
          about: string;
          portfolio: string;
        };
      };
      guham: {
        name: string;
        subtitle: string;
        links: {
          web: string;
          app: string;
        };
      };
    };
    footerText: string;
  };
  allLinks: string;
};

const createLanguagePack = (values: TranslationResources) => ({
  translation: values,
});

export const langEN = createLanguagePack({
  lang: "EN",
  home: "Home",
  about: "About",
  game: "Game",
  usefulTools: "Event Tools",
  roleRouletteDescription:
    "Use it for mafia games, liar games, and other role assignments!",
  singleRoleRouletteDescription:
    "Host can reveal roles or pass the device around for players to check their roles!",
  teamBuilderDescription: "Create teams quickly and easily!",
  luckyDrawDescription: "Random number drawing or prize lottery tool",
  quizDescription: "Interactive quiz tool with buzzer, O/X, and answer modes",
  team: "Team",
  individual: "Individual",
  cooperative: "Cooperative",
  players: "Players",
  offlineUse: "For Offline",
  letsPlay: "Let's play",
  backToHome: "Back to Home",
  createRoom: "Create Room",
  joinRoom: "Join Room",
  reconnect: "Reconnect",
  room: "Room",
  private: "Private",
  status: "Status",
  password: "Password",
  enterRoomName: "Enter the room name",
  usernameRequired: "Please enter your username",
  roomNameRequired: "Please enter a room name",
  roomInGame: "Cannot join - game is already in progress",
  enterUsername: "Enter your nickname",
  leaveRoom: "Leave Room",
  start: "Start",
  startGame: "Start Game",
  rule: "Rule",
  joinMessage: " joined the room.",
  leaveMessage: " left the room.",
  typeMessage: "Type your message.",
  chat: "Chat",
  onlineUsers: "Online Users",
  // Private chat translations
  publicChat: "Public",
  privateChat: "Private",
  newConversation: "New Conversation",
  selectParticipants: "Select participants",
  selectAtLeastOne: "Select at least one participant",
  selectedOnePlayer: "1 participant selected",
  selectedMultiplePlayers: "{{count}} participants selected",
  noAvailablePlayers: "No available players",
  startConversation: "Start Conversation",
  noConversations: "No conversations yet",
  clickNewToStart: "Click 'New Conversation' to start",
  noMessages: "No messages",
  joinedConversation: "joined the conversation",
  leftConversation: "left the conversation",
  round: "Round",
  howToPlay: "How to Play",
  gameSoon: "Game will be started soon...",
  gameOver: "Game Over",
  backToRoom: "Back to Room",
  enterMemo: "Enter the memo",
  gameSetting: "Game Setting",
  contact: "Contact",
  links: "Links",
  featuredWork: "Featured Work",
  currentProject: "Current Project",
  skillStack: "Skill Stack",
  coreSkill: "Core",
  programming: "Programming",
  framework: "Framework",
  others: "Others",
  addAI: "Add AI",
  skip: "Skip",
  serverDisconnected: "Server connection lost",
  reconnecting: "Reconnecting...",
  retry: "Retry",
  aiPlayer: "AI Player",
  reconnectionDialog: {
    title: "Reconnect to Game",
    message1: "Connection was lost for",
    seconds: " seconds",
    message2: ".",
    question: "Would you like to rejoin the game?",
    autoCancel: " seconds until automatic exit",
    reconnect: "Rejoin",
    leave: "Leave",
  },
  services: "Services",
  servicesSubtitle: "Level up your gatherings!",
  About: {
    name: "Developer.",
    intro: about_en,
    title: {
      noAI: "Practical Software Development",
      withAI: "Programming with AI",
      ios: "iOS Application",
      flutter: "Flutter",
      react: "React",
    },
    onGoing: {
      lingtopleDesc:
        "A creative lab for games and utility apps that make everyday life better.",
      inGraceTitle: "Christian Platform",
      inGraceDesc: "",
    },
    desc: {
      selfTaught: "Self-taught developer",
      designSkill: "Game, app and solution design and planning skill",
      ideaToImplementation: "From idea to implementation",
      multipleDevelop:
        "Experience managing iOS, Android, Flutter, and Frontend development simultaneously within the company.",

      amplifyWithAI: "Exploring a new world with Cursor",
      aiCodeReview: "AI-powered code review and refactoring",

      iosLeadDev: "Main iOS developer at current company",
      swiftExperience:
        "Experienced in Swift-based development across SwiftUI, Storyboard, programmatic layouts and WatchOS",

      flutterLeadProject:
        "Leading a Flutter migration project, unifying native iOS and Android into a single app",
      flutterNativePerf: "Method channel integration with native code",
      flutterWebFirst:
        "Currently developing a cross-platform app with a web-first approach",

      reactFullstack:
        "Full-stack app development using React, TypeScript, Redux, Node.js and Firebase",
      reactStyling:
        "Styling with Tailwind and Sass for responsive, maintainable UI",
      reactSocket: "Building real-time, multi-user content using socket server",
      reactBackend: "Creating enterprise-level backend with ASP.NET and Oracle",
    },
  },
  J2H: {
    title: "Way back Home",
    Square: "Square",
    Sky: "Sky",
    Forest: "Forest",
    River: "River",
    City: "City",
    rules: j2h_rules_en,
    setting: "Add Area",
    squareMessage:
      "Choose your next area.\nIf you don't choose, random area will be selected.",
    hometownAssignment: "Hometown Assignment",
    movementRules: "Movement Rules",
    gamePhases: "Game Phases",
    squarePhase: "Square Phase",
    areaPhase: "Area Phase",
    communicationRules: "Communication Rules",
    areaInfo: "Area Info",
    areaAndWinCondition: "Area and Win Condition",
    winCondition: "Win Condition",
    playersInArea: "Players in Area",
    playersInHometown: "Players in Hometown",
    strategyAndExample: "Strategy & Example",
    strategyTips: "Strategy Tips",
    strategyGuide: "Strategy Guide",
    gameExample: "Game Example",
    gameExampleTitle: "Game Progress Example",
  },
  WTB: {
    title: "Hidden AI",
    rules: wtb_rules_en,
    humanPlayer: "Human Player",
    gamePhases: "Game Phases",
    answerPhase: "Answer Phase",
    votingPhase: "Voting Phase",
    aiVotingPhase: "AI Voting Phase",
    scoringSystem: "Scoring System",
    successTips: "Success Tips",
    answerSubmitted: "Answer submitted",
    enterAnswer: "Enter your answer...",
    submitAnswer: "Submit Answer",
    votePrompt: "Vote for the most AI-like answer",
    selectAnswer: "Select an answer to vote",
    roundResults: "Round Results",
    topAnswers: "Most Voted Answers",
    aiVotingTitle: "Find the AI",
    voteSubmitted: "Vote submitted",
    selectBot: "Select who you think is the AI",
    finalResults: "Game Results",
    botReveal: "AI Players Revealed",
    votingResults: "Voting Results",
    correctGuesses: "players correctly identified the AI",
    gameResults: "Game Results",
    correctGuessers: "Players who found the AI",
    myAnswer: "My Answer",
    selected: "Selected",
    mostVoted: "Most Voted",
    points: "points",
    continue: "Continue",
    botCount: "AI Player",
    answerTime: "Answer Time",
    votingTime: "Voting Time",
    language: "Language",
  },
  featuredWorks: featuredWorkLocalizations_en,
  viewProject: "View Project",
  aboutGridItemType: aboutGridItemLocalization_en,
  SingleRoleRoulette: {
    title: "Role Roulette for 1 Device",
    rules: single_roulette_rules_en,
    inProgress: "In Progress",
    waiting: "Waiting",
    rouletteMode: "Roulette Mode",
    moderatorMode: "Moderator Mode",
    notSet: "Not Set",
    enterRoleName: "Please enter role name.",
    roleNameExists: "Role name already exists.",
    roleNameLength: "Role name must be within {{maxLength}} characters.",
    quantityMinimum: "Quantity must be 1 or more.",
    enterBasicRole: "Please enter basic role.",
    setTotalPlayersMinimum: "Total players must be 1 or more.",
    totalLabelCountExceedsTotalPlayers:
      "Total label count exceeds total players.",
    gameMode: "Game Mode",
    totalPlayers: "Total Players",
    rouletteModeDescription: "Check one by one",
    moderatorModeDescription: "View all results",
    playerCount: "Player Count:",
    add: "Add",
    people: "people",
    selectVoterCount: "Select Voter Count",
    secretVoteDescription:
      "Pass the device around for each player to vote agree or disagree secretly. Results will be shown after all votes are cast.",
    // UI texts
    player: "Player",
    checkRole: "Check Role",
    confirmComplete: "Confirm",
    passToNextPlayer: "Press to check your role and pass to next player",
    passToNextPlayerAfterCheck:
      "After checking your role,\npress 'Confirm' and pass to next player",
    allPlayersConfirmed: "All players have confirmed their roles.",
    secretVote: "Secret Vote",
    viewResults: "View Results",
    voteResults: "Vote Results",
    allVotesComplete: "All votes have been completed.",
    confirmVoteResults: "Would you like to view the vote results?",
    roleDistributionResults: "Role Distribution Results",
    votingInProgress: "Voting in Progress",
    agree: "Agree",
    disagree: "Disagree",
    complete: "Complete",
  },
  TeamBuilder: {
    title: "Team Builder",
    rules: team_builder_rules_en,
    // Settings
    teamAssignmentSettings: "Team Assignment Settings",
    totalPlayers: "Total Players",
    people: "people",
    teamCount: "Team Count",
    teams: "teams",
    maxTeamsCanBeSet: "Max {{count}} teams can be set",
    startTeamAssignment: "Start Team Assignment",
    // Results
    teamAssignmentResults: "Team Assignment Results",
    totalPlayersAssignedMessage:
      "Total {{totalPlayers}} players assigned to {{teamCount}} teams",
    team: "Team",
    peopleUnit: "people",
    playerNumberUnit: "",
    fullListPlayerOrder: "Full List (Player Number Order)",
    reassignTeams: "Reassign Teams",
  },
  LuckyDraw: {
    title: "Lucky Draw",
    rules: lucky_draw_rules_en,
    // Mode buttons
    numberMode: "Number Mode",
    prizeMode: "Prize Mode",
    // Drawing states
    waiting: "Waiting...",
    drawing: "Drawing...",
    stopDrawing: "STOP!",
    drawnNumber: "Drawn Number",
    winningPrize: "Winning Prize",
    startDrawing: "START!",
    draw: "Draw",
    drawingComplete: "Drawing Complete",
    // Status
    remainingNumbers: "Remaining numbers",
    remainingPrizes: "Remaining prizes",
    units: "",
    drawHistory: "Draw History",
    restart: "Restart",
    backToSettings: "Finish",
    // Number mode
    numberModeSettings: "Number Drawing Settings",
    minimumNumber: "Minimum Number",
    maximumNumber: "Maximum Number",
    drawFromRange: "Draw numbers from {{minNumber}} to {{maxNumber}}",
    maxNumberMustBeGreater:
      "Maximum number must be greater than minimum number",
    startDraw: "Start Drawing",
    // Prize mode
    prizeModeSettings: "Prize Drawing Settings",
    addPrize: "Add Prize",
    prizeName: "Prize",
    enterPrizeName: "Enter prize name",
    quantity: "Quantity:",
    add: "Add",
    registeredPrizes: "Registered Prizes",
    addPrizesFirst: "Please add prizes first",
  },
  RoleDistributor: {
    title: "Role Roulette",
    rules: role_distributor_rules_en,
    // Settings
    gameSettingsTitle: "Role Assignment Game Settings",
    hostMode: "Host Mode",
    hostModeDescription:
      "Host can see all participants' assignment results (Host is excluded from role assignment)",
    gameStartInfo: "Roles can be added and assigned after game starts",
    // UI Labels
    notSet: "Not Set",
    peopleExpected: "people expected",
    specialRoles: "Special Roles",
    gameInProgress: "Game in Progress",
    waiting: "Waiting",
    roleStatus: "Role Status",
    settings: "Settings",
    status: "Status",
    expand: "Expand",
    collapse: "Collapse",
    roleSettingsHost: "Role Settings",
    inProgress: "In Progress",
    hostRevealMode: "Host can see all participants' assignment results",
    unassigned: "Unassigned",
    moderator: "Moderator",
    roleAssignmentResults: "Role Assignment",
    myRole: "My Role",
    hostExcluded: "(Host excluded)",
    totalParticipants: "Total Participants",
    participating: "Participating",
    // Form inputs
    basic: "Basic",
    special: "Special",
    basicPlaceholder: "e.g., Villager",
    specialPlaceholder: "e.g., Mafia, Police",
    addedSpecialRoles: "Added Special Roles",
    delete: "Delete",
    quantity: "Quantity",
    addSpecialRole: "Add Role",
    // Buttons
    endDistribution: "End Distribution",
    edit: "Edit",
    start: "Start",
    completeSettings: "Complete",
    settingsCompleted: "Settings Completed",
    // Error messages
    enterRoleName: "Please enter role name.",
    roleNameTooLong: "Role name must be within {{maxLength}} characters.",
    roleNameExists: "Role name already exists.",
    quantityMinimum: "Quantity must be 1 or more.",
    enterBasicRole: "Please enter basic role.",
    noParticipants: "No participants.",
    specialRolesExceedPlayers:
      "Total count of special roles exceeds available participants ({{count}}).",
    serverDisconnected: "Server connection lost. Please try again.",
    settingsCompleteFailed: "Failed to complete settings. Please try again.",
    // Action-related
    actionPhaseActive: "Action Round Active",
    actionPhaseInactive: "Action Round Ready",
    startActionPhase: "Start Action Phase",
    endActionPhase: "End Action Phase",
    phaseStartedAt: "Started at",
    myActions: "My Actions",
    canUseActions: "Actions can be used",
    waitForPhase: "Wait for action phase",
    recentUsages: "Recent Usage History",
    agree: "Agree",
    disagree: "Disagree",
    selectTarget: "Select Target",
    selectVoteTarget: "Select voting target",
    makeChoice: "Make Your Choice",
    makeSecretChoice: "Secret Voting",
    secretVoteNote:
      "Individual choices are not revealed, only totals are disclosed.",
    confirm: "Confirm",
    cancel: "Cancel",
    actionPhaseNotActive: "Action phase is not active.",
    actionAlreadyUsed: "This action has already been used.",
    noAvailableTargets: "No available targets.",
    selectRoleToSee: "Select a role to see",
    noRolesToSee: "No roles available to see.",
    host: "Host",
    actionPhase: "Action Phase",
    specialActions: "Action",
    actionHistory: "Action Usage History",
    noActions: "You have no special actions.",
    noHistory: "No action usage history yet.",
    used: "Used",
    actionResults: "Action Results",
    publicResults: "Public Results",
    yourResults: "Your Results",
    noResults: "No results to display.",
    result: "Result",
    gameSettingsTip: "Useful tips for game settings and progression.",
    clickToStart: "Click to Start",
    clickToEnd: "Click to End",
    selectActions: "Select Actions",
    assignedActions: "Assigned Actions",
    // Preset-related
    presetTitle: "Game Presets",
    selectGame: "Select Game",
    selectCharacter: "Select Character",
    characterDescription: "Character Description",
    faction: "Faction",
    goodFaction: "Good",
    evilFaction: "Evil",
    mafiaFaction: "Mafia",
    citizenFaction: "Citizen",
    avalonGuide: "Avalon Guide",
    mafiaGuide: "Mafia Guide",
    specialAbilities: "Special Abilities",
    noSpecialAbilities: "No special abilities",
    select: "Select",
    defaultRoleSection: "Default Role",
    specialRoleSection: "Special Roles",
    // 능력별 이름과 설명
    assassinate: "Assassinate",
    assassinateDesc: "Eliminate another player",
    protect: "Protect",
    protectDesc: "Shield another player from harm",
    investigate: "Investigate",
    investigateDesc: "Reveal another player's identity",
    nominate: "Public Nomination",
    nominateDesc:
      "Publicly nominate another player (who nominated whom is revealed)",
    vote: "Secret Nomination",
    voteDesc:
      "Nominate another player (only final nomination counts are revealed)",
    vote_choice: "Public Vote",
    vote_choiceDesc:
      "Vote for/against a proposal (individual choices are revealed)",
    secret_vote_choice: "Secret Vote",
    secret_vote_choiceDesc:
      "Vote for/against a proposal (only vote totals are revealed)",
    see_roles: "See Roles",
    see_rolesDesc:
      "View players who have specific roles (displayed at game start)",
    // Action result messages
    assassinationSuccess: "{{playerName}} was assassinated.",
    assassinationFailed: "Assassination failed due to protection.",
    protectionSuccess: "Protected {{playerName}}.",
    investigationResult: "{{playerName}}'s role is {{role}}.",
    actionComplete: "{{actionName}} usage complete",
    nominateSuccess: "{{playerName}} nominated {{targetName}}.",
    voteChoiceSuccess: "{{playerName}} voted {{choice}}.",
    seeRolesSuccess: "Confirmed role information.",
    // See roles related
    seeRolesLabel: "See Roles (Show player names with these roles when game starts)",
    seeRolesTitle: "Role Information",
    seeRolesNote: "These players have one of the target roles (order randomized)",
    seeRolesPreview: "Target roles",
    // Timer and action modification
    seconds: "sec",
    noTimeLimit: "No time limit",
    timerExpired: "Time has expired.",
    invalidDuration: "Please enter a valid time.",
    startAction: "Start Action",
    endAction: "End Action",
    modifyAction: "Modify Action",
    modifyActionDesc: "You can modify or cancel this action.",
    changeTarget: "Change Target",
    cancelAction: "Cancel",
    tapToModify: "Tap to modify",
  },
  Dealerjack: {
    title: "Blackjack",
    rules: dealerjack_rules_en,
    ...dealerjack_translations_en,
    // Game UI (keeping common UI elements here)
    dealer: "Dealer",
    handValue: "Hand Value",
    showing: "Showing",
    placeBet: "Place Your Bet",
    bet: "Bet",
    yourTurn: "Your Turn!",
    roundResults: "Round Results",
    payout: "Payout",
    lose: "Loss",
    waitingForGame: "Waiting for game to start...",
    enableChat: "Enable Chat",
    disableChat: "Disable Chat",
    // In-game settings
    completeSettings: "Complete Settings",
    configuringGame: "Configuring game...",
    settingsInProgress: "Settings in Progress",
    hostConfiguringGame: "Host is configuring the game settings",
    pleaseWait: "Please wait...",
    // Battle Mode specific
    placeBattleBet: "Place Your Battle Bet",
    availableChips: "Own Chips",
    battleTurn: "Your Battle Turn!",
    battleResults: "Battle Results",
    battleRoundsRemaining: "Rounds Remaining",
    totalChips: "Total Chips",
    viewFinalResults: "View Final Results",
    finalBattleResults: "Final Battle Results",
    battleWinner: "WINNER",
    finalRank: "Final Rank",
    profit: "profit",
    backToLobby: "Back to Lobby",
    bettingPhase: "Betting Phase",
    playerTurn: "Player Turn",
    sortedByChips: "Sorted by chips",
    betPlaced: "Bet Placed",
  },
  Quiz: quizRuleLocalization.en.quiz,
  FightSimulator: fightSimulatorRuleLocalization.en.FightSimulator,
  ProductLinks: {
    pageTitle: "My Services",
    pageDescription: "Explore all my services and platforms",
    developerCard: {
      title: "Jay Shin",
      description: "Full-stack developer creating innovative digital experiences",
      viewPortfolio: "View Full Portfolio",
    },
    services: {
      lingple: {
        subtitle: "Level up your gatherings!",
        links: {
          home: "Lingple Home",
          about: "About",
          portfolio: "Featured Works",
        },
      },
      guham: {
        name: "Guham",
        subtitle:
          "A Christian united platform where ministries, churches, and communities connect",
        links: {
          web: "Web Version",
          app: "App Version",
        },
      },
    },
    footerText: "Made with ❤️ by Jay Shin",
  },
  allLinks: "All Links",
});

export const langKO = createLanguagePack({
  lang: "KR",
  home: "홈",
  about: "소개",
  game: "게임",
  usefulTools: "이벤트 툴",
  roleRouletteDescription:
    "마피아, 라이어 게임 등 필요한 역할 배정에 활용해보세요!",
  singleRoleRouletteDescription:
    "하나의 기기로 사회자가 역할을 알려주거나, 기기를 돌려보며 각자의 역할을 확인할 수 있습니다.",
  teamBuilderDescription: "빠르고 간단하게 팀을 편성하세요!",
  luckyDrawDescription: "숫자 추첨이나 경품 뽑기에 활용하세요!",
  quizDescription: "부저, OX, 답변 모드가 있는 인터랙티브 퀴즈 도구",
  team: "팀전",
  individual: "개인전",
  cooperative: "협동",
  players: "플레이어",
  offlineUse: "오프라인용",
  letsPlay: "시작하기",
  backToHome: "홈으로",
  createRoom: "방 생성하기",
  joinRoom: "방 참여하기",
  reconnect: "Reconnect",
  room: "방제",
  private: "비공개",
  status: "상태",
  password: "비밀번호",
  enterRoomName: "방 제목을 입력하세요",
  usernameRequired: "사용자 이름을 입력해주세요",
  roomNameRequired: "방 제목을 입력하세요",
  roomInGame: "게임이 진행 중인 방에는 참가할 수 없습니다",
  enterUsername: "닉네임을 입력하세요",
  leaveRoom: "나가기",
  start: "시작",
  startGame: "게임시작",
  rule: "규칙",
  joinMessage: " 님이 참가했습니다.",
  leaveMessage: " 님이 퇴장했습니다.",
  typeMessage: "메시지를 입력하세요.",
  chat: "채팅",
  onlineUsers: "플레이어",
  // Private chat translations
  publicChat: "공개",
  privateChat: "비공개",
  newConversation: "새 대화",
  selectParticipants: "참여자 선택",
  selectAtLeastOne: "최소 1명 이상 선택하세요",
  selectedOnePlayer: "1명 선택됨",
  selectedMultiplePlayers: "{{count}}명 선택됨",
  noAvailablePlayers: "선택 가능한 플레이어가 없습니다",
  startConversation: "대화 시작",
  noConversations: "아직 대화가 없습니다",
  clickNewToStart: "'새 대화'를 클릭하여 시작하세요",
  noMessages: "메시지 없음",
  joinedConversation: "님이 대화에 참여했습니다",
  leftConversation: "님이 대화에서 나갔습니다",
  round: "라운드",
  howToPlay: "설명서",
  gameSoon: "잠시 후 게임이 시작됩니다...",
  gameOver: "게임 종료",
  backToRoom: "방으로 돌아가기",
  enterMemo: "메모를 입력하세요",
  gameSetting: "게임 설정",
  contact: "연락처",
  links: "링크",
  featuredWork: "주요 프로젝트",
  currentProject: "진행 중",
  skillStack: "보유 기술",
  coreSkill: "핵심",
  programming: "프로그래밍",
  framework: "프레임워크",
  others: "기타",
  addAI: "AI 추가",
  skip: "스킵",
  serverDisconnected: "서버 연결이 끊어졌습니다",
  reconnecting: "재연결 중...",
  retry: "재시도",
  aiPlayer: "AI 플레이어",
  reconnectionDialog: {
    title: "게임 재참여",
    message1: "게임 연결이 끊어진 지",
    seconds: "초",
    message2: "가 지났습니다.",
    question: "게임에 다시 참여하시겠습니까?",
    autoCancel: "초 후 자동으로 나가집니다",
    reconnect: "재참여",
    leave: "나가기",
  },
  services: "서비스",
  servicesSubtitle: "모임을 더욱 스마트하게!",
  About: {
    name: "Developer.",
    intro: about_ko,
    title: {
      noAI: "실무형 소프트웨어 개발",
      withAI: "프로그래밍 with AI",
      ios: "iOS 애플리케이션",
      flutter: "Flutter",
      react: "React",
    },
    onGoing: {
      lingtopleDesc: "게임, 실생활에 유용한 유틸리티 앱 등의 컨텐츠 연구소",
      inGraceTitle: "크리스천 플랫폼 '구함'",
      inGraceDesc: "guham.net",
    },
    desc: {
      selfTaught: "비전공, 독학, 광범위 개발자",
      designSkill: "게임, 앱, 솔루션 기획 및 설계",
      ideaToImplementation: "아이디어부터 구현까지",
      multipleDevelop: "회사 내 iOS, Android, Flutter, Frontend 동시 담당 경험",

      amplifyWithAI: "Cursor로 신세계를 맛보는 중",
      aiCodeReview: "AI 기반 코드 리뷰 및 수정",

      iosLeadDev: "현 회사 주요 개발 분야",
      swiftExperience:
        "Swift, SwiftUI, Storyboard, Programming layout 및 WatchOS 개발",

      flutterLeadProject:
        "iOS와 Android를 하나의 Flutter 앱으로 통합하는 프로젝트 리딩",
      flutterNativePerf: "네이티브 함수와 연동하는 메소드 채널링",
      flutterWebFirst: "웹 중심의 크로스플랫폼 앱 개발 중",

      reactFullstack:
        "React, TypeScript, Redux, Node.js, Firebase Hosting 등을 활용한 풀스택 앱 개발",
      reactStyling: "Tailwind와 Sass를 이용한 반응형 UI 스타일링",
      reactSocket: "Socket서버를 활용한 실시간 다중 접속 콘텐츠 개발",
      reactBackend: "ASP.NET과 Oracle을 활용한 엔터프라이즈 백엔드 구현",
    },
  },

  J2H: {
    title: "귀향",
    Square: "광장",
    Sky: "하늘",
    Forest: "숲",
    River: "강",
    City: "도시",
    rules: j2h_rules_ko,
    setting: "지역 추가",
    squareMessage:
      "다음 목적지를 고르세요.\n선택을 하지 않으면 임의 장소가 선택됩니다.",
    hometownAssignment: "귀향 배정",
    movementRules: "이동 규칙",
    gamePhases: "게임 단계",
    squarePhase: "광장 단계",
    areaPhase: "지역 단계",
    communicationRules: "커뮤니케이션 규칙",
    areaInfo: "지역 정보",
    areaAndWinCondition: "지역과 승리 조건",
    winCondition: "승리 조건",
    playersInArea: "지역 플레이어",
    playersInHometown: "귀향 플레이어",
    strategyAndExample: "전략 & 예시",
    strategyTips: "전략 팁",
    strategyGuide: "전략 가이드",
    gameExample: "게임 예시",
    gameExampleTitle: "게임 진행 예시",
  },
  WTB: {
    title: "히든 AI",
    rules: wtb_rules_ko,
    humanPlayer: "인간 플레이어",
    gamePhases: "게임 단계",
    answerPhase: "답변 단계",
    votingPhase: "투표 단계",
    aiVotingPhase: "AI 투표 단계",
    scoringSystem: "점수 시스템",
    successTips: "성공 팁",
    answerSubmitted: "답변 제출됨",
    enterAnswer: "답변을 입력하세요...",
    submitAnswer: "답변 제출",
    votePrompt: "AI의 답변으로 보이는 답변에 투표하세요",
    selectAnswer: "투표할 답변을 선택하세요",
    roundResults: "라운드 결과",
    topAnswers: "가장 많은 투표를 받은 답변",
    aiVotingTitle: "AI 찾기",
    voteSubmitted: "투표 완료",
    selectBot: "AI라고 생각되는 플레이어를 선택하세요",
    finalResults: "게임 결과",
    botReveal: "AI 플레이어 공개",
    votingResults: "투표 결과",
    correctGuesses: "명이 AI를 정확히 찾아냈습니다",
    gameResults: "게임 결과",
    correctGuessers: "AI를 찾아낸 플레이어",
    myAnswer: "내 답변",
    selected: "선택됨",
    mostVoted: "최다 득표",
    points: "점",
    continue: "계속하기",
    botCount: "AI 플레이어",
    answerTime: "답변 시간",
    votingTime: "투표 시간",
    language: "게임 언어",
  },
  featuredWorks: featuredWorkLocalizations_ko,
  viewProject: "프로젝트 보기",
  aboutGridItemType: aboutGridItemLocalization_ko,
  SingleRoleRoulette: {
    title: "역할 룰렛 for 1 device",
    rules: single_roulette_rules_ko,
    inProgress: "진행중",
    waiting: "대기 중",
    rouletteMode: "룰렛 모드",
    moderatorMode: "사회자 모드",
    notSet: "미설정",
    enterRoleName: "역할명을 입력하세요.",
    roleNameExists: "이미 존재하는 역할명입니다.",
    roleNameLength: "역할명은 {{maxLength}}자 이내여야 합니다.",
    quantityMinimum: "수량은 1 이상이어야 합니다.",
    enterBasicRole: "기본 역할을 입력하세요.",
    setTotalPlayersMinimum: "총 참가자는 1명 이상이어야 합니다.",
    totalLabelCountExceedsTotalPlayers:
      "총 라벨 수가 총 참가자 수를 초과합니다.",
    gameMode: "게임 모드",
    totalPlayers: "총",
    rouletteModeDescription: "한 명씩 확인",
    moderatorModeDescription: "전체 결과 보기",
    playerCount: "인원 수:",
    add: "추가",
    people: "명",
    selectVoterCount: "투표 인원 선택",
    secretVoteDescription:
      "핸드폰을 돌려가며 각 플레이어가 찬성 또는 반대를 비공개로 투표합니다. 모든 투표가 완료되면 결과가 표시됩니다.",
    // UI texts
    player: "플레이어",
    checkRole: "역할 확인하기",
    confirmComplete: "확인 완료",
    passToNextPlayer: "역할 확인하기를 누르고 다음 사람에게 넘겨주세요",
    passToNextPlayerAfterCheck:
      "역할을 확인했으면 '확인 완료'를 누르고 다음 플레이어에게 넘겨주세요",
    allPlayersConfirmed: "모든 플레이어가 역할을 확인했습니다.",
    secretVote: "비공개 찬반투표",
    viewResults: "결과 확인하기",
    voteResults: "투표 결과",
    allVotesComplete: "모든 투표가 완료되었습니다.",
    confirmVoteResults: "투표 결과를 확인하시겠습니까?",
    roleDistributionResults: "역할 분배 결과",
    votingInProgress: "투표 진행중",
    agree: "찬성",
    disagree: "반대",
    complete: "완료",
  },
  TeamBuilder: {
    title: "팀 편성기",
    rules: team_builder_rules_ko,
    // Settings
    teamAssignmentSettings: "팀 편성 설정",
    totalPlayers: "총 인원 수",
    people: "명",
    teamCount: "팀 개수",
    teams: "팀",
    maxTeamsCanBeSet: "최대 {{count}}팀까지 설정 가능",
    startTeamAssignment: "팀 편성 시작",
    // Results
    teamAssignmentResults: "팀 편성 결과",
    totalPlayersAssignedMessage:
      "총 {{totalPlayers}}명이 {{teamCount}}팀으로 편성되었습니다",
    team: "팀",
    peopleUnit: "명",
    playerNumberUnit: "번",
    fullListPlayerOrder: "전체 명단 (플레이어 번호 순)",
    reassignTeams: "다시 편성하기",
  },
  LuckyDraw: {
    title: "행운의 뽑기",
    rules: lucky_draw_rules_ko,
    // Mode buttons
    numberMode: "숫자 추첨",
    prizeMode: "경품 추첨",
    // Drawing states
    waiting: "준비 중...",
    drawing: "추첨 중...",
    stopDrawing: "스톱!",
    drawnNumber: "추첨된 숫자",
    winningPrize: "당첨 경품",
    startDrawing: "추첨 시작!",
    draw: "추첨하기",
    drawingComplete: "추첨 완료",
    // Status
    remainingNumbers: "남은 숫자",
    remainingPrizes: "남은 경품",
    units: "개",
    drawHistory: "추첨 기록",
    restart: "재시작",
    backToSettings: "종료하기",
    // Number mode
    numberModeSettings: "숫자 추첨 설정",
    minimumNumber: "최소 숫자",
    maximumNumber: "최대 숫자",
    drawFromRange:
      "{{minNumber}}부터 {{maxNumber}}까지의 숫자 중에서 추첨합니다",
    maxNumberMustBeGreater: "최대 숫자는 최소 숫자보다 커야 합니다",
    startDraw: "추첨 시작",
    // Prize mode
    prizeModeSettings: "경품 추첨 설정",
    addPrize: "경품 추가",
    prizeName: "경품",
    enterPrizeName: "경품명",
    quantity: "수량",
    add: "추가",
    registeredPrizes: "등록된 경품",
    addPrizesFirst: "경품을 먼저 추가해주세요",
  },
  RoleDistributor: {
    title: "역할 룰렛",
    rules: role_distributor_rules_ko,
    // Settings
    gameSettingsTitle: "역할 배정 게임 설정",
    hostMode: "사회자 모드",
    hostModeDescription:
      "방장이 모든 참가자의 배정 결과를 볼 수 있습니다 (방장은 역할 배정에서 제외됩니다)",
    gameStartInfo: "게임 시작 후 역할을 추가하고 배정할 수 있습니다",
    // UI Labels
    notSet: "미설정",
    peopleExpected: "명 예상",
    specialRoles: "특수",
    gameInProgress: "게임 진행 중",
    waiting: "대기 중",
    roleStatus: "역할 현황",
    settings: "설정",
    status: "현황",
    expand: "펼치기",
    collapse: "접기",
    roleSettingsHost: "역할 설정",
    inProgress: "진행중",
    hostRevealMode: "방장이 모든 참가자의 배정 결과를 볼 수 있습니다",
    unassigned: "미배정",
    moderator: "사회자",
    roleAssignmentResults: "역할 배정",
    myRole: "내 역할",
    hostExcluded: "(방장 제외)",
    totalParticipants: "총 참가자",
    participating: "참가 중",
    // Form inputs
    basic: "기본",
    special: "특수",
    basicPlaceholder: "예: 시민",
    specialPlaceholder: "예: 마피아, 경찰",
    addedSpecialRoles: "추가된 특수역할",
    delete: "삭제",
    quantity: "수량",
    addSpecialRole: "역할 추가",
    // Buttons
    endDistribution: "분배종료",
    edit: "수정하기",
    start: "시작하기",
    completeSettings: "설정 완료",
    settingsCompleted: "설정 완료",
    // Error messages
    enterRoleName: "역할명을 입력하세요.",
    roleNameTooLong: "역할명은 {{maxLength}}자 이내여야 합니다.",
    roleNameExists: "이미 존재하는 역할명입니다.",
    quantityMinimum: "수량은 1 이상이어야 합니다.",
    enterBasicRole: "기본 역할을 입력하세요.",
    noParticipants: "참여 인원이 없습니다.",
    specialRolesExceedPlayers:
      "특수역할의 인원 수 총합이 배정 가능한 인원 수({{count}}명)보다 많습니다.",
    serverDisconnected: "서버와의 연결이 끊어졌습니다. 다시 시도해주세요.",
    settingsCompleteFailed: "설정 완료에 실패했습니다. 다시 시도해주세요.",
    // Action-related
    actionPhaseActive: "액션 라운드 진행중",
    actionPhaseInactive: "액션 라운드 대기",
    startActionPhase: "액션 단계 시작",
    endActionPhase: "액션 단계 종료",
    phaseStartedAt: "시작 시간",
    myActions: "내 액션",
    canUseActions: "액션 사용 가능",
    waitForPhase: "액션 단계를 기다리세요",
    recentUsages: "최근 사용 기록",
    agree: "찬성",
    disagree: "반대",
    selectTarget: "대상을 선택하세요",
    selectVoteTarget: "투표할 대상을 선택하세요",
    makeChoice: "선택하세요",
    makeSecretChoice: "비공개 찬반투표",
    secretVoteNote: "개별 선택은 공개되지 않으며, 총계만 공개됩니다.",
    confirm: "확인",
    cancel: "취소",
    actionPhaseNotActive: "액션 단계가 활성화되지 않았습니다.",
    actionAlreadyUsed: "이미 사용한 액션입니다.",
    noAvailableTargets: "선택 가능한 대상이 없습니다.",
    selectRoleToSee: "확인할 역할을 선택하세요",
    noRolesToSee: "확인 가능한 역할이 없습니다.",
    host: "방장",
    actionPhase: "액션 단계",
    specialActions: "액션",
    actionHistory: "액션 사용 기록",
    noActions: "보유한 액션이 없습니다.",
    noHistory: "아직 사용한 액션이 없습니다.",
    used: "사용됨",
    actionResults: "액션 결과",
    publicResults: "공개 결과",
    yourResults: "당신의 결과",
    noResults: "표시할 결과가 없습니다.",
    result: "결과",
    gameSettingsTip: "게임 설정 및 진행에 대한 유용한 팁들입니다.",
    clickToStart: "클릭하여 시작",
    clickToEnd: "클릭하여 종료",
    selectActions: "액션 선택",
    assignedActions: "배정된 액션",
    // Preset-related
    presetTitle: "게임 프리셋",
    selectGame: "게임 선택",
    selectCharacter: "직업 선택",
    characterDescription: "직업 설명",
    faction: "진영",
    goodFaction: "선",
    evilFaction: "악",
    mafiaFaction: "마피아",
    citizenFaction: "시민",
    avalonGuide: "아발론 가이드",
    mafiaGuide: "마피아 가이드",
    specialAbilities: "특수 능력",
    noSpecialAbilities: "특수 능력 없음",
    select: "선택",
    defaultRoleSection: "기본 역할",
    specialRoleSection: "특수 역할",
    // 능력별 이름과 설명
    assassinate: "암살",
    assassinateDesc: "다른 플레이어를 제거",
    protect: "보호",
    protectDesc: "다른 플레이어를 보호",
    investigate: "조사",
    investigateDesc: "다른 플레이어의 정체 확인",
    nominate: "공개 지목",
    nominateDesc:
      "다른 플레이어를 공개적으로 지목 (누가 누구를 지목했는지 공개)",
    vote: "비공개 지목",
    voteDesc: "다른 플레이어를 지목 (최종 득표수만 공개)",
    vote_choice: "공개 찬반투표",
    vote_choiceDesc: "안건에 대해 찬성/반대 (개별 선택이 공개)",
    secret_vote_choice: "비공개 찬반투표",
    secret_vote_choiceDesc: "안건에 대해 찬성/반대 (찬반 총계만 공개)",
    see_roles: "역할 확인",
    see_rolesDesc:
      "특정 역할을 가진 플레이어 확인 (게임 시작 시 표시)",
    // Action result messages
    assassinationSuccess: "{{playerName}}님이 암살당하였습니다.",
    assassinationFailed: "암살이 보호로 인해 실패했습니다.",
    protectionSuccess: "{{playerName}}님을 보호했습니다.",
    investigationResult: "{{playerName}}님의 역할은 {{role}}입니다.",
    actionComplete: "{{actionName}} 사용 완료",
    nominateSuccess: "{{playerName}}님이 {{targetName}}님을 지목했습니다.",
    voteChoiceSuccess: "{{playerName}}님이 {{choice}}했습니다.",
    seeRolesSuccess: "역할 정보 확인 완료.",
    // See roles related
    seeRolesLabel: "역할 확인 대상 (게임 시작 시 해당 역할의 플레이어 이름 표시)",
    seeRolesTitle: "역할 정보",
    seeRolesNote: "다음 플레이어들이 해당 역할 중 하나를 가지고 있습니다 (순서 무작위)",
    seeRolesPreview: "확인 대상 역할",
    // Timer and action modification
    seconds: "초",
    noTimeLimit: "시간 제한 없음",
    timerExpired: "시간이 종료되었습니다.",
    invalidDuration: "올바른 시간을 입력해주세요.",
    startAction: "액션 시작",
    endAction: "액션 종료",
    modifyAction: "액션 수정",
    modifyActionDesc: "이 액션을 수정하거나 취소할 수 있습니다.",
    changeTarget: "대상 변경",
    cancelAction: "취소하기",
    tapToModify: "수정하기",
  },
  Dealerjack: {
    title: "블랙잭",
    rules: dealerjack_rules_ko,
    ...dealerjack_translations_ko,
    // Game UI (keeping common UI elements here)
    dealer: "딜러",
    handValue: "핸드 값",
    showing: "공개",
    placeBet: "베팅하기",
    bet: "베팅",
    yourTurn: "당신 차례입니다!",
    roundResults: "라운드 결과",
    payout: "배당",
    lose: "패배",
    waitingForGame: "게임 시작을 기다리는 중...",
    enableChat: "채팅 켜기",
    disableChat: "채팅 끄기",
    // In-game settings
    completeSettings: "설정 완료",
    configuringGame: "게임 설정 중...",
    settingsInProgress: "설정 진행 중",
    hostConfiguringGame: "방장이 게임 설정을 구성 중입니다",
    pleaseWait: "잠시만 기다려 주세요...",
    // Battle Mode specific
    placeBattleBet: "대결 베팅하기",
    availableChips: "보유 칩",
    battleTurn: "당신의 대결 턴!",
    battleResults: "대결 결과",
    battleRoundsRemaining: "남은 라운드",
    totalChips: "총 칩",
    viewFinalResults: "최종 결과 보기",
    finalBattleResults: "최종 대결 결과",
    battleWinner: "승리자",
    finalRank: "최종 순위",
    profit: "수익",
    backToLobby: "로비로 돌아가기",
    bettingPhase: "베팅 단계",
    playerTurn: "플레이어 턴",
    sortedByChips: "칩 수 기준 정렬",
    betPlaced: "베팅 완료",
  },
  Quiz: quizRuleLocalization.ko.quiz,
  FightSimulator: fightSimulatorRuleLocalization.ko.FightSimulator,
  ProductLinks: {
    pageTitle: "나의 서비스",
    pageDescription: "제가 만든 모든 서비스와 플랫폼을 소개합니다",
    developerCard: {
      title: "Jay Shin",
      description: "혁신적인 디지털 경험을 만드는 풀스택 개발자",
      viewPortfolio: "전체 포트폴리오 보기",
    },
    services: {
      lingple: {
        subtitle: "모임을 더욱 스마트하게!",
        links: {
          home: "Lingple 홈",
          about: "소개",
          portfolio: "주요 작업물",
        },
      },
      guham: {
        name: "구함",
        subtitle: "사역과 교회, 그리고 공동체가 이어지는 크리스천 연합 플랫폼",
        links: {
          web: "웹 버전",
          app: "앱 버전",
        },
      },
    },
    footerText: "Made with ❤️ by Jay Shin",
  },
  allLinks: "모든 링크",
});
